import axios from 'axios';

const DEFAULT_PROVIDER = 'transbank';

const ORDER_ENDPOINTS = {
    transbank: '/api/autoservicio/create-order-im30',
    getnet: '/api/autoservicio/create-order-getnet'
};

let cachedProvider = null;

export const getPaymentProvider = async (apiUrl) => {
    if (cachedProvider) return cachedProvider;

    try {
        const response = await axios.get(`${apiUrl}/api/config`, { timeout: 5000 });
        const provider = response.data?.config?.PAYMENT_PROVIDER;
        cachedProvider = provider === 'getnet' ? 'getnet' : DEFAULT_PROVIDER;
    } catch (error) {
        console.warn('No se pudo leer PAYMENT_PROVIDER, se usa Transbank:', error.message);
        cachedProvider = DEFAULT_PROVIDER;
    }

    console.log(`Proveedor de pago del tótem: ${cachedProvider}`);
    return cachedProvider;
};

export const getOrderEndpoint = async (apiUrl) => {
    const provider = await getPaymentProvider(apiUrl);
    return ORDER_ENDPOINTS[provider] || ORDER_ENDPOINTS[DEFAULT_PROVIDER];
};

export const resetProviderCache = () => {
    cachedProvider = null;
};

const PaymentProviderService = { getPaymentProvider, getOrderEndpoint, resetProviderCache };
export default PaymentProviderService;
